import {branch, mapProps, renderNothing} from 'recompose'

import compose from 'lodash/flowRight'
import type {ComponentType} from 'react'
import {connect} from 'react-redux'

import type {DialogProps} from '../../../../hocs/withDialogContainer'
import withDialogContainer from '../../../../hocs/withDialogContainer'
import type {State} from '../../../../reducers/types'
import {getBuildType, getProject} from '../../../../selectors'
import {DialogType, stringifyId} from '../../../../types'
import type {BuildTypeId, Id, ProjectInternalId} from '../../../../types'
import InvestigationHistoryPopup from '../InvestigationHistoryPopup/InvestigationHistoryPopup'

type OwnProps = {
  id: Id | null | undefined
  buildTypeId: BuildTypeId | null | undefined
}
type StateProps = {
  projectInternalId: ProjectInternalId | null | undefined
}
type OwnPropsDummy = OwnProps & StateProps

const mapStateToProps = (state: State, {buildTypeId}: OwnProps): StateProps => {
  const buildType = getBuildType(state, buildTypeId)
  return {
    projectInternalId: getProject(state, buildType?.projectId)?.internalId,
  }
}

export const BuildTypeInvestigationHistoryPopupDummy: ComponentType<OwnPropsDummy> = compose(
  withDialogContainer(DialogType.INVESTIGATION_HISTORY, (state, props: OwnPropsDummy) =>
    stringifyId(props.id),
  ),
  mapProps(({id, ...restProps}: DialogProps<OwnPropsDummy>) => ({
    ...restProps,
    locator: `buildTypeId=${stringifyId(restProps.buildTypeId)}`,
  })),
  branch((props: DialogProps<OwnPropsDummy>) => !props.isOpened, renderNothing),
)(InvestigationHistoryPopup)
export default connect(mapStateToProps, {})(BuildTypeInvestigationHistoryPopupDummy)
